import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { css, styled } from 'styled-components';
import { getErrorId, getInfoId } from '@hivebrite/utils';
import { AdditionalInformation } from "../../additional-information/src";
import { Box } from "../../box/src";
import { INFORMATION_TOOLTIP_SIZES, InformationTooltip, } from "../../information-tooltip/src";
import { Required } from "../../label/src";
import { RadioInput } from './RadioInput';
export const RADIOS_INPUT_DIRECTION = ['horizontal', 'vertical'];
export const RadiosInput = ({ ariaDescribedBy, ariaLabel, dataTestId, direction = 'horizontal', disabled = false, error, hideError = false, horizontalSpacing, id, info, inputs, label, name, onBlur, onChange, onFocus, required, selectedValue, tooltip, tooltipPosition, variant = 'normal', }) => {
    const hasError = Boolean(error);
    const errorId = useMemo(() => getErrorId(id), [id]);
    const hasInfo = Boolean(info);
    const infoId = useMemo(() => getInfoId(id), [id]);
    const isVertical = direction === 'vertical';
    return (_jsxs("fieldset", Object.assign({ role: "radiogroup" }, ((hasError || ariaDescribedBy) && {
        'aria-describedby': [
            hasError && errorId,
            hasInfo && infoId,
            ariaDescribedBy,
        ]
            .filter(Boolean)
            .join(' '),
    }), (hasError && {
        'aria-invalid': hasError,
    }), (ariaLabel && {
        'aria-label': ariaLabel,
    }), { "aria-required": required ? 'true' : undefined, children: [label && (_jsxs(StyledLegend, { "$disabled": disabled, variant: variant, children: [label, required && _jsx(Required, {}), tooltip && (_jsx(Box, { ml: 2, children: _jsx(InformationTooltip, { inline: true, position: tooltipPosition, size: INFORMATION_TOOLTIP_SIZES.SMALL, children: typeof tooltip === 'function' ? tooltip() : tooltip }) }))] })), _jsx(Box, { "data-testid": dataTestId, flexDirection: isVertical ? 'column' : 'row', justifyContent: "flex-start", children: inputs.map((radio, index) => (_jsx(Box, { mb: isVertical ? 4 : 0, ml: index > 0 && !isVertical ? horizontalSpacing !== null && horizontalSpacing !== void 0 ? horizontalSpacing : 8 : 0, children: _jsx(RadioInput, Object.assign({ checked: selectedValue === radio.value, disabled: disabled, onBlur: onBlur, onChange: onChange, onFocus: onFocus, width: "inherit" }, radio, { id: radio.id || `${name}_${radio.value}`, variant: variant })) }, radio.value))) }), error && typeof error === 'string' && !hideError && (_jsx(AdditionalInformation, { id: id, type: "error", children: error })), info && typeof info === 'string' && (_jsx(AdditionalInformation, { id: id, type: "info", children: info }))] })));
};
const StyledLegend = styled(Box).attrs(({ $disabled, theme, variant }) => ({
    as: 'legend',
    mb: theme.label.marginToLegendRadioInputs,
    opacity: $disabled ? theme.input[variant].disabled.opacity : 1,
})) `
  ${({ $disabled, theme }) => css `
    color: ${theme.label.color};
    font-size: ${theme.label.fontSize};
    font-weight: ${theme.label.fontWeight};
    padding-bottom: 0 !important;
    user-select: none;
    ${$disabled && `pointer-events: none;`}
  `}
`;
//# sourceMappingURL=RadiosInput.js.map